<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <h3>Recepcion Recepcion Materia Prima Por Proveedor</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label for="form-control-label">Seleccione un Rango de Fechas</label>
                            <date-picker v-model="fechas" :range="true" format="DD-MM-YYYY" :editable="false" :clearable="true" value-type="YYYY-MM-DD"></date-picker>
                        </div>
                    </div>

                    <div class="col">
                        <!-- <select name="" id="" v-model="mps_id" class="form-control">
                            <option :value="m.id" v-for="m in materias_primas" :key="m.id">{{m.nombre}}</option>
                        </select> -->
                        
                        <div class="form-group">
                            <label for="form-control-label">Seleccione Materia Prima</label>
                            <v-select class="" :reduce="option => option.id" v-model="mps_id" :options="materias_primas" label="nombre" multiple>
                                <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                </template>
                            </v-select>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <label for="form-control-label">Seleccione Proveedores</label>
                            <v-select class="" :reduce="option => option.id" v-model="empresas_id" :closeOnSelect="false" :options="proveedores" label="nombre" multiple>
                                <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                </template>
                            </v-select>
                        </div>
                    </div>

                    

                    <div class="col">
                        
                        <div class="form-group">
                            <label for="form-control-label">Seleccione Destino</label>
                            <v-select class="" :reduce="option => option.id" v-model="destinos_id" :options="destinos" label="nombre" multiple>
                                <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                </template>
                            </v-select>
                        </div>
                    </div>

                    <div class="col">
                        <button class="btn btn-primary btn-icon" @click="cargar_datos">Cargar</button>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="tableFixHead" style="width:100%" v-show="datos.length > 0">
                        <table class="table table-bordered">
                            <thead class="thead-skyblue2">
                                <tr>
                                    <th class="fixed">Empresa</th>
                                    <!-- <th class="fixed" v-for="m in mps_seleccionadas" :key="m.id">{{m.nombre}} S/R</th>
                                    <th class="fixed background-red" v-for="m in mps_seleccionadas" :key="m.hash">{{m.nombre}} C/R</th> -->
                                    <th class="fixed" v-for="m in mps_seleccionadas" :key="m.id">{{m.nombre}}</th>

                                    <th class="fixed">Total</th>
                                </tr>
                                <!-- <tr>
                                    <th class="fixed-2"></th>
                                    <th class="fixed-2 text-center" v-for="m in mps_seleccionadas" :key="m.id">
                                        <table>
                                            <tr>
                                                <td style="width:100%">C/R</td>
                                                <td style="width:100%">S/R</td>
                                            </tr>
                                        </table>
                                    </th>
                                </tr> -->
                            </thead>
                            <tbody>
                                <tr v-for="d in datos" :key="d.id">
                                    <td>{{d.nombre}}</td>
                                    <td :class="`text-center ${m.class}`" v-for="m in d.mps" :key="m.hash1">
                                        {{m.total_kilos |formatear_miles}}
                                    </td>
                                    <td class="text-center">{{d.total_kilos | formatear_miles}}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>


                
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data:()=>({
        fechas:[],
        proveedores:[],
        datos:[],
        mps_id:[],
        destinos_id:[],
        empresas_id:[],
        materias_primas:[],
        mps_seleccionadas:[],
        destinos:[]
    }),
    mounted(){
        this.cargar_materias_primas();
    },
    methods:{
        async cargar_materias_primas(){
          await this.axios.get(`${this.api}/mps_tipo?limit=999999999`,this.cabeceras_json,).then(res=>{
                this.materias_primas = res.data.data.data;
            }).catch(e=>{
                //console.log(e);
            });
            this.cargar_destinos();
        },

        async cargar_destinos(){
          await this.axios.get(`${this.api}/destinos`,this.cabeceras_json,).then(res=>{
                this.destinos = res.data.data;
            }).catch(e=>{
                //console.log(e);
            });
            this.cargar_proveedores();
        },

        async cargar_proveedores(){
            /* await this.axios.get(`${this.api}/empresas?tipo_empresa_ids=4&agrupada_en_null=not_null&limit=9999999999`,this.cabeceras_json).then((res)=>{
            this.proveedores = res.data.data.data
            ////console.log('res',res.data.data.data);
          }).catch((e)=>{
            //console.log(e);
          }); */
          await this.axios.get(`${this.api}/proveedores`,this.cabeceras_json).then((res)=>{
            this.proveedores = res.data.data;
            console.log('res',res.data.data);
          }).catch((e)=>{
            //console.log(e);
          });
        },

        async filtrarProveedores(search){
          await this.axios.get(`${this.api}/empresas?nombre=${search}&tipo_empresa_ids=4&agrupada_en_null=not_null&limit=9999999999`,this.cabeceras_json).then((res)=>{
            this.proveedores = res.data.data.data
            ////console.log('res',res.data.data.data);
          }).catch((e)=>{
            //console.log(e);
          });
          ////console.log('search',search)
          ////console.log('col',col)
        },

        async cargar_datos(){
            if(this.fechas[0] != null && this.fechas[0] != undefined){
                await this.axios.get(`${this.api}/reportes/materia_prima?mps_id=${this.mps_id}&empresas_id=${this.empresas_id}&desde=${this.fechas[0]}&hasta=${this.fechas[1]}&destinos_ids=${this.destinos_id}`,this.cabeceras_json).then(res=>{
                    //console.log(res.data.data);
                    this.datos = res.data.data.data;
                    this.mps_seleccionadas = res.data.data.materias_primas;
                    
                }).catch(e=>{
                    //console.log(e);
                });
            }
            
        },

        devuelve_valor(mp_id,dato){
            return dato.materias_primas.find(m=>m.mps_id == mp_id).cantidad
        }

        
    },
    computed:{

        ...mapState(['api','cabeceras_json','token'])
    }
}
</script>
<style>
.tableFixHead          { overflow: auto; height: 600px; }
.tableFixHead thead th { position: sticky; top: 0; z-index: 1; }

/* Just common table stuff. Really. */
table  { border-collapse: collapse; width: 100%; }
th, td { padding: 8px 16px; }
th     { background:#427391; color:#fff }

</style>